module.exports = __webpack_public_path__ + "assets/images/slope-religion/mobile.svg?v=4d9128fc";